import React, { useEffect, useState } from 'react';

import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { Box, Container, Divider } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';
import PageSubheader from '~/components/Common/Elements/PageSubheader';
import { Port } from '~/components/Cruises/pages/Ports/types';

import portService from '~/services/cruises/PortService';

import PortForm from './components/PortForm';
import PortPOIs from './components/PortPOIs';

export default function PortsEditPage() {
  const { portId } = useParams<{ portId: string }>();
  const [port, setPort] = useState<Port | null>(null);

  useEffect(() => {
    portService.getPortById(portId).then((port) => {
      setPort(port);
    });
  }, [portId]);

  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>Edit Port</title>
      </Helmet>

      <PageHeader title="Edit Port" backButton="/cruises/ports" />

      {port && (
        <>
          <PortForm port={port} />

          <Box mt={4}>
            <Divider />
            <Box mt={2}>
              <PageSubheader title="Crawled Points of Interest" />
              <PortPOIs port={port} />
            </Box>
          </Box>
        </>
      )}
    </Container>
  );
}
